import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  DatePicker,
  Input,
  Space,
  Row,
  Col,
  ConfigProvider,
  Typography,
  Divider,
  Table,
  Form,
  InputNumber,
  Modal,
} from "antd";
import { DownloadOutlined, EditOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import "../styles/Vehicle.css";
import {
  fetchdata,
  updatepaidtoOwnerData,
} from "src/redux/actions/VehicleMasterAction";
import { useDispatch, useSelector } from "react-redux";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import saveAs from "file-saver";

const { Title, Text } = Typography;
export default function VehicleListCards() {
  const dispatch = useDispatch();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState<any>(null);
  const [form] = Form.useForm();
  const [month, setMonth] = useState<any>(null);
  const [cabId, setCabId] = useState("");

  const cabDetails = useSelector(
    (state: any) => state.vehiclemaster?.cabDetails,
  );
  const loading = useSelector((state: any) => state.vehiclemaster.loading);
  const update = useSelector((state: any) => state.vehiclemaster.update);

  const monthSummary = useSelector(
    (state: any) => state.vehiclemaster?.monthSummary,
  );

  const weeklyStatements = useSelector(
    (state: any) => state.vehiclemaster?.weeklyStatements || [],
  );

  const selectedCab = cabDetails || {};

  const summaryDetails = React.useMemo(
    () => [
      {
        label: "M. Id",
        value: selectedCab?.vehicleId || "-",
        color: "#52c41a",
      },
      { label: "Cab Id", value: selectedCab?.cabId || "-", color: "#faad14" },
      {
        label: "Owner Name",
        value: selectedCab?.ownerName || "-",
        color: "#1890ff",
      },
      {
        label: "Joined Date",
        value: selectedCab?.joiningDate || "-",
        color: "#722ed1",
      },
    ],
    [selectedCab],
  );

  const handleFetch = () => {
    dispatch(fetchdata(cabId, month));
  };
  useEffect(() => {
    if (update?.success) {
      handleFetch();
    }
  }, [update?.success]);

  const tableData = React.useMemo(() => {
    if (!weeklyStatements.length) return [];

    const rows: any[] = [];

    weeklyStatements.forEach((weekItem: any) => {
      const creditRows =
        (weekItem.credits || []).map((credits: any) => ({
          rowType: "CREDIT",
          date: credits.date,
          bookingId: credits.bookingId,
          creditAmount: credits.fare,
          fare: credits.fare,
          // paidAmount: "-",
          // paidDate: "-",
          // transaction: "-",
        })) || [];

      const paymentRows =
        (weekItem.payments || []).map((payment: any) => ({
          rowType: "PAYMENT",
          // date: payment.paidDate,
          // bookingId: "-",
          // creditAmount: "-",
          paidAmount: payment.paidAmount,
          paidDate: payment.paidDate,
          transaction: payment.transaction,
        })) || [];

      const combinedRows = [...creditRows, ...paymentRows];

      if (combinedRows.length === 0) {
        combinedRows.push({
          rowType: "EMPTY",
          // date: "-",
          // bookingId: "-",
          // creditAmount: "-",
          // paidAmount: "-",
          // paidDate: "-",
          // transaction: "-",
        });
      }

      combinedRows.forEach((row, index) => {
        rows.push({
          key: `${weekItem.weekRange}-${row.rowType}-${index}`,

          tripWeek: weekItem.weekRange,
          fromDate: weekItem.fromDate,
          toDate: weekItem.toDate,
          amount: weekItem.amount,
          payable: weekItem.toPay,
          paidtoOwner: weekItem.paidtoOwner || "0",
          paidownerDate: weekItem.paidownerDate || "-",
          paidownbookId: weekItem.paidownbookId || "0",

          ...row,

          rowSpan: index === 0 ? combinedRows.length : 0,
          
        });
      });
    });

    return rows;
  }, [weeklyStatements]);

  const handleUpdate = (values: any) => {
    const payload = {
      cabId: cabId,
      paidtoOwner: values.paid_to_owner,
      BookingId: values.booking,
      paidownerDate: values.date,
      fromDate: editingRecord.fromDate,
      toDate: editingRecord.toDate,
    };

    dispatch(updatepaidtoOwnerData(payload));
    setIsEditModalOpen(false);
    form.resetFields();
  };

  const handleEdit = (record: any) => {
    setEditingRecord(record);
    // form.setFieldsValue(record);
    setIsEditModalOpen(true);
    console.log("Editing Record:", record);
  };

  const columns = [
    {
      title: "Trip Week",
      dataIndex: "tripWeek",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (value: any, record: any) =>
        record.rowType === "CREDIT" ? value : "-",
    },
    {
      title: "Booking ID",
      dataIndex: "bookingId",
      render: (value: any, record: any) =>
        record.rowType === "CREDIT" ? value : "0",
    },
    {
      title: "Credit",
      dataIndex: "fare",
      render: (value: any, record: any) =>
        record.rowType === "CREDIT" ? value : "0",
    },
    {
      title: "Trip Turnover",
      dataIndex: "amount",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Payable",
      dataIndex: "payable",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Paid to Owner",
      dataIndex: "paidtoOwner",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Paid to Owner Date",
      dataIndex: "paidownerDate",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Paid to Owner BookingId",
      dataIndex: "paidownbookId",
      render: (value: any, record: any) => ({
        children: (
          <div>
            <strong>{value}</strong>
            <br />
            <span style={{ fontSize: 12, opacity: 0.8 }}>{record.range}</span>
          </div>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      render: (value: any, record: any) =>
        record.rowType === "PAYMENT" ? value : "0",
    },
    {
      title: "Paid Date",
      dataIndex: "paidDate",
      render: (value: any, record: any) =>
        record.rowType === "PAYMENT" ? value : "-",
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction",
      render: (value: any, record: any) =>
        record.rowType === "PAYMENT" ? value : "0",
    },

    {
      title: "Action",
      dataIndex: "action",
      width: 120,
      render: (_: any, record: any) => ({
        children: (
          <button
            style={{
              padding: "4px 10px",
              background: "#88429A",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              cursor: "pointer",
              fontSize: 13,
            }}
            onClick={() => handleEdit(record)}
          >
            <EditOutlined style={{ fontSize: 16, color: "#fff" }} />
          </button>
        ),
        props: { rowSpan: record.rowSpan },
      }),
    },
  ];

  const exportToExcel = (data: any[], fileName = "Vehicle_Statement") => {
    if (!data || data.length === 0) return;

    const formattedData = data.map((row) => ({
      "Trip Week": row.tripWeek,
      "From Date": row.fromDate || "-",
      "To Date": row.toDate || "-",
      Date: row.date,
      "Booking ID": row.booking,
      Credit: row.credit,
      "Trip Turnover": row.amount,
      Payable: row.payable,
      "Paid to Owner": row.paidtoOwner,
      "Paid Owner Date": row.paidownerDate,
      Paid: row.paid,
      "Transaction ID": row.transactions,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <ConfigProvider
    >
      <div className="vehicle-container">
        <div className="header-bar">
          <Title level={3} className="page-title">
            Vehicle Accounts Statement
          </Title>
        </div>

        <Card
          className="filter-card enhanced"
          style={{
            borderRadius: 16,
            margin: "-10px 0 10px 0",
            background: "transparent",
            boxShadow: "none",
          }}
          bodyStyle={{ padding: "0px 0px 0px 10px" }}
        >
          <Row
            gutter={16}
            align="middle"
            wrap={false}
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <Col flex="0 0 auto">
              <Space size="middle">
                <DatePicker
                  picker="month"
                  className="date-input"
                  onChange={(date, dateString) => {
                    setMonth(dateString as string);
                  }}
                />
                <Input
                  placeholder="Enter Cab ID"
                  className="input-style"
                  value={cabId}
                  onChange={(e) => setCabId(e.target.value)}
                />
                <Button
                  type="primary"
                  size="middle"
                  style={{ padding: "0 24px", backgroundColor: "#884299" }}
                  onClick={handleFetch}
                >
                  GO
                </Button>

                <Button
                  icon={<DownloadOutlined />}
                  size="middle"
                  style={{
                    padding: "0 16px",
                    background: "linear-gradient(45deg, #159957, #155799)",
                    color: "white",
                  }}
                  // onClick={() => exportToExcel(tableRows)}
                  onClick={() =>
                    exportToExcel(tableData, `${cabId}_${month}_Statement`)
                  }
                >
                  Export
                </Button>
              </Space>
            </Col>
            <Col xs={12} sm={6} md={4}>
              {tableData.length > 0 && (
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 30,
                    background:
                      "linear-gradient(135deg, rgb(243 128 128) 0%, rgb(107 17 17) 100%)",
                    boxShadow: "0 2px 8px rgba(255, 77, 79, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "0px 0px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#ffffffff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    Net Payable
                  </Text>
                  <Text strong style={{ fontSize: 16, color: "#ffffffff" }}>
                    {monthSummary?.netPayable || 0}
                  </Text>
                </Card>
              )}
            </Col>
          </Row>
        </Card>
        {tableData.length > 0 && (
          <Card
            style={{
              borderRadius: 16,
              background: "linear-gradient(135deg,#f9fafb,#e3e6f7)",
              // marginBottom: 24,
            }}
            bodyStyle={{ padding: 10 }}
          >
            <Row gutter={[0, 8]} justify="space-around">
              {summaryDetails.map((item, index) => (
                <Col xs={12} sm={6} md={4} key={index}>
                  <Card
                    bordered={false}
                    style={{
                      borderRadius: 10,
                      background: item.color + "25",
                      textAlign: "center",
                      // minHeight: 50,
                      height: "80%",
                      boxShadow: `0 1px 6px ${item.color}50`,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: item.color,
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      {item.label}
                    </Text>
                    <Title level={5} style={{ marginTop: 6, marginBottom: 0 }}>
                      {item.value}
                    </Title>
                  </Card>
                </Col>
              ))}
            </Row>

            <Divider style={{ margin: "0px 0 20px 0" }} />

            <Row gutter={[8, 16]} justify="space-between" align="middle">
              <Col xs={12} sm={6} md={4}>
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #fff2f0 0%, #ffe8e6 100%)",
                    boxShadow: "0 2px 8px rgba(255, 77, 79, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "10px 6px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#000000ff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    Credit
                  </Text>
                  <Text strong style={{ fontSize: 16, color: "#ff4d4f" }}>
                    {monthSummary?.monthlyCredit || 0}
                  </Text>
                </Card>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #e6f7ff 0%, #e8f4fd 100%)",
                    boxShadow: "0 2px 8px rgba(24, 144, 255, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "10px 6px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#000000ff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    Trip Turnover
                  </Text>
                  <Text strong style={{ fontSize: 18, color: "#1890ff" }}>
                    {monthSummary?.monthlyTotalTurn || 0}
                  </Text>
                </Card>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #fffbe6 0%, #fff7e6 100%)",
                    boxShadow: "0 2px 8px rgba(250, 173, 20, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "10px 6px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#000000ff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    To pay
                  </Text>
                  <Text strong style={{ fontSize: 18, color: "#faad14" }}>
                    {monthSummary?.monthlyToPay || 0}
                  </Text>
                </Card>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #f3e8ff 0%, #f0e6f8 100%)",
                    boxShadow: "0 2px 8px rgba(114, 46, 209, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "10px 6px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#000000ff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    Paid
                  </Text>
                  <Text strong style={{ fontSize: 18, color: "#722ed1" }}>
                    {monthSummary?.monthlyPaid || 0}
                  </Text>
                </Card>
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card
                  hoverable
                  bordered={false}
                  style={{
                    borderRadius: 8,
                    background:
                      "linear-gradient(135deg, #fff0f6 0%, #fce7f3 100%)",
                    boxShadow: "0 2px 8px rgba(235, 47, 150, 0.12)",
                    textAlign: "center",
                    height: "100%",
                  }}
                  bodyStyle={{ padding: "10px 6px" }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      color: "#000000ff",
                      display: "block",
                      fontWeight: 600,
                    }}
                  >
                    Paid to Owner
                  </Text>
                  <Text strong style={{ fontSize: 18, color: "#eb2f96" }}>
                    {monthSummary?.monthlyPaidOwner || 0}
                  </Text>
                </Card>
              </Col>
            </Row>
          </Card>
        )}
        <Table
          columns={columns}
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          dataSource={tableData}
          pagination={false}
          bordered
          size="middle"
          rowClassName={(_, index) =>
            index % 2 === 0 ? "row-light" : "row-dark"
          }
        />
        <Modal
          title={
            <div
              style={{
                backgroundColor: "purple",
                color: "white",
                textAlign: "center",
                padding: "10px 0",
                borderRadius: "4px",
                fontSize: "15px",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              Edit Trip Details
            </div>
          }
          open={isEditModalOpen}
          onCancel={() => setIsEditModalOpen(false)}
          footer={null}
        >
          <Form
            form={form}
            onFinish={handleUpdate}
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Form.Item name="booking" label="Booking ID">
              <Input />
            </Form.Item>

            <Form.Item name="date" label="Date">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item name="paid_to_owner" label="Paid to Owner">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item wrapperCol={{ span: 24 }}>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "center",
                  gap: "4%",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ backgroundColor: "green" }}
                >
                  submit
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </ConfigProvider>
  );
}
